// extracted by mini-css-extract-plugin
export default {"brandPromo":"sF-z","carousel":"tF-z"};